module.exports = __webpack_public_path__ + "media/images/icons/material/microsoft-32fb98d0fbb999faaf2ee88e1a02d009.svg";